import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CandidateHeader from "../Candidate/Candidate Navbar/Header";
import ExamNavbar from "./ExamNavbar";
import { toast } from 'react-toastify';
import LoadingSpinner from '../Utils/LoadingSpinner'

export default function ExamPage() {
  const [course, getCourse] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);


  // ====================== list of exams names data from api ======================
  useEffect(() => {

    axios.get("https://pl.aspireitacademy.com/listcourseapi").then((res) => {
      console.log("res:", res.data);
      const filteredArray = res.data.filter(item => item.total_question_count >= 60);
      // console.log(filteredArray);
      getCourse(filteredArray);
      setLoader(false);
    }).catch(error => {
      toast.warning(error);
      setLoader(false);
    });

  }, []);

  // ====================== Select Exam ======================
  function handleClick(item) {
    navigate("/go-to-exam", {
      state: {
        exam: item,
      },
    });
  }

  return (
    <section>
      {/* ====================== Header and Navbar ====================== */}
      <CandidateHeader />
      <ExamNavbar />
      {/* ====================== body ====================== */}
      {loader ? <LoadingSpinner /> :
        <>
          <div className="container">
            <div
              className="course-container m-3 my-4 px-3 pt-4 pb-5"
              style={{ boxShadow: "0px 0px 3px 0px #c1c1c1" }}
            >
              <h1 className="text-center">IT EXAM</h1>
              <p className="text-center">
                Aspire Academy provide free MCQ Q&As for certification exams.
              </p>

              <div className="course-select-container p-3 d-flex justify-content-center gap-3 flex-wrap">
                {course.map((item) => {
                  return (
                    <button
                      key={item.id}
                      className="btn btn-outline-primary text-capitalize"
                      onClick={() => handleClick(item)}
                      style={{ padding: "10px", width: "200px" }}
                    >
                      {item.name}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      }
    </section>
  );
}
